import "./sections.scss";
import React, { useState } from "react";
import RedButton from "../../../components/buttons/defaultButton/redButton/RedButton";
import Search from "../../../components/search/Search";
import SettingsTable from "../../../components/settingsTable/SettingsTable";
import Pagination from "../../../components/pagination/Pagination";
import FullRedButton from "../../../components/buttons/defaultButton/fullRedButton/FullRedButton";
import Modal from "../../../components/modals/Modal";
import { useGetPageQuery, useSendFormMutation } from "../../../redux/services/velmartAPI";
import EditTitleModal from "../../../components/modals/editTitleModal/EditTitleModal";
import AddModal from "../../../components/modals/addModal/AddModal";
import AddDependanceModal from "../../../components/modals/addDependanceModal/AddDependanceModal";
import useDebounse from "../../../helpers/useDebounse";
import { ErrorHandler } from "../../../helpers/ErrorHandler";
import { useNavigate } from "react-router-dom";

const Sections = () => {
    const navigate = useNavigate();

    const [addModalOpen, setAddModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [dependenceModalOpen, setDependenceModalOpen] = useState(false);

    const [editElement, setEditElement] = useState({ id: 0, title: "", parentId: 0, sort: 0 });
    const [itemsList, setItemsList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setSearchValue] = useState("");

    const debounceSearch = useDebounse(searchValue, 500);
    const searchParams = "&search=" + debounceSearch;
    const pageParams = "&page=" + currentPage;

    const { data: departments, refetch: refetchDepartments } = useGetPageQuery(
        "departments?per_page=10" + pageParams + searchParams
    );
    const [sendForm, { error }] = useSendFormMutation();

    const listCheckHandler = (e) => {
        if (e.target.checked) {
            setItemsList([...itemsList, +e.target.value]);
        } else if (!e.target.checked) {
            setItemsList([...itemsList.filter((id) => id !== +e.target.value)]);
        }
    };

    async function editElementHandler(title, sort, parentId) {
        const formData = {
            title: title ? title : editElement.title,
            parent_id: parentId ? parentId : editElement.parentId,
            sort: sort ? sort : editElement.sort,
        };

        try {
            await sendForm({ url: "departments/" + editElement.id, method: "PUT", body: formData }).unwrap();
        } catch (error) {
            ErrorHandler(error, navigate);
        }

        await refetchDepartments();
    }

    const copyElementHandler = async (id) => {
        try {
            await sendForm({ url: "departments/" + id, method: "POST" }).unwrap();
        } catch (error) {
            ErrorHandler(error, navigate);
        }

        await refetchDepartments();
    };

    const addElementHandler = async (title) => {
        const formData = {
            title: title,
        };

        try {
            await sendForm({ url: "departments", body: formData }).unwrap();
        } catch (error) {
            ErrorHandler(error, navigate);
        }

        await refetchDepartments();
    };

    const deleteElementHandler = async (id) => {
        try {
            await sendForm({ url: "departments/" + id, method: "DELETE" }).unwrap();
        } catch (error) {
            ErrorHandler(error, navigate);
        }

        await refetchDepartments();
    };
    const deleteElementsHandler = async () => {
        const formData = {
            ids: itemsList,
        };
        try {
            await sendForm({ url: "departments", method: "DELETE", body: formData }).unwrap();
        } catch (error) {
            ErrorHandler(error, navigate);
        }

        setItemsList([]);
        await refetchDepartments();
    };

    const checkAllHandler = (isChecked) => {
        if (isChecked) {
            setItemsList(departments.data.map((design) => +design.id));
        } else {
            setItemsList([]);
        }
    };

    return (
        <>
            {departments && (
                <div className="page-content__container">
                    <AddModal
                        isOpen={addModalOpen}
                        title={"Додати"}
                        btnTitle={"Додати"}
                        setIsOpen={setAddModalOpen}
                        addElemen={addElementHandler}
                    />
                    <AddDependanceModal
                        isOpen={dependenceModalOpen}
                        title={"Додати залежність"}
                        btnTitle={"Додати залежність"}
                        setIsOpen={setDependenceModalOpen}
                        onSave={editElementHandler}
                        listLink={"departments"}
                    />
                    <EditTitleModal
                        isOpen={editModalOpen}
                        title={"Редагувати"}
                        btnTitle={"Редагувати"}
                        setIsOpen={setEditModalOpen}
                        onSave={editElementHandler}
                        editElement={editElement}
                    />
                    <div className="elements">
                        <RedButton text={"Додати +"} onClick={() => setAddModalOpen(true)} />
                        <div className="elements__search">
                            <Search placeholder={"Пошук..."} value={searchValue} onChange={setSearchValue} />
                        </div>
                        <div className="elements__table">
                            <SettingsTable
                                setEditModalOpen={setEditModalOpen}
                                setDependenceModalOpen={setDependenceModalOpen}
                                dataList={departments.data}
                                deleteElementHandler={deleteElementHandler}
                                setEditElement={setEditElement}
                                editElementHandler={editElementHandler}
                                listCheckHandler={listCheckHandler}
                                itemsList={itemsList}
                                checkAllHandler={checkAllHandler}
                                copyElementHandler={copyElementHandler}
                            />
                        </div>
                        <div className="elements__footer">
                            <Pagination
                                pageCount={departments.last_page}
                                setCurrentPage={setCurrentPage}
                                fromValue={departments.from}
                                toValue={departments.to}
                                totalValue={departments.total}
                            />
                            <div className="elements__footer-button">
                                <FullRedButton text={"Видалити обране"} onClick={deleteElementsHandler} />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Sections;
